export default class Permission {
  setControls(path) {
    let status
    if (localStorage.getItem('Auto_Boutique_Dash_User_Type') != 'superadmin') {
      if (localStorage.getItem('Auto_Boutique_controls')) {
        let controls = JSON.parse(localStorage.getItem('Auto_Boutique_controls'))
        const found = controls.find((control) => control.url == path)

        if (found) {
          status = false
        } else {
          status = true
        }
      }
    } else {
      status = false
    }
    return status
  }
  allowed(path) {
    let status
    if (localStorage.getItem('Auto_Boutique_Dash_User_Type') != 'superadmin') {
      if (localStorage.getItem('Auto_Boutique_permissions')) {
        let controls = JSON.parse(localStorage.getItem('Auto_Boutique_permissions'))

        const found = controls.find((control) => control.url == path)
        if (found) {
          status = false
        } else {
          status = true
        }
      }
    } else {
      status = false
    }
    return status
  }
}
